// extracted by mini-css-extract-plugin
export default {"test":"styles_test__Is6yf","center":"styles_center__FEsX4"};